/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { StyledProductSearchResultsProps } from './types';

const baseStyles = () => css`
    .control-group {
        display: none;
    }

    .small-tablet-filters {
        display: none;
    }

    .desktop-filters {
        display: grid;
        &.desktop-filters--hidden {
            display: none;
        }
    }

    ${smallTablet(css`
        .control-group {
            display: block;
        }

        .divider {
            display: none;
        }

        .small-tablet-filters {
            display: flex;
        }

        .desktop-filters {
            display: none;
        }
    `)}

    .spelling-suggestion-notice {
        margin-bottom: var(--layout-spacing-24);
    }

    .search-results-grid .grid-item-container,
    .link-wrapper,
    .card-link,
    .card-link > span {
        display: grid;
        min-width: 0;
    }

    .link-wrapper {
        position: relative;
        height: auto;
    }

    .card-link {
        width: 100%;
        padding: 0.4rem;
        border-radius: 1.2rem;

        & > span > * {
            height: auto;
        }
    }

    .control-group {
        position: relative;
    }

    .control-group-skeleton {
        height: 100%;
        width: 100%;
        position: absolute;
        gap: 0.4rem;
        display: none;
    }
`;

const loadingStyles = () => css`
    .control-group-skeleton {
        display: flex;
    }

    .control-group-content {
        visibility: hidden;
    }
`;

export const styles = ({ isLoading }: StyledProductSearchResultsProps) => {
    return css`
        ${baseStyles()}
        ${isLoading && loadingStyles()}
    `;
};
